import {DeviceType} from '../components/Controler';
import {AccountInfo} from '@azure/msal-browser';
import {UUID} from 'crypto';
import {AudioLevelAPI} from '../components/AudioLevel';

//export const SERVER_URL: string = 'http://localhost:8080/'; //Localhost
export const SERVER_URL: string = 'https://enersound.azurewebsites.net/'; //Prod
// export const SERVER_URL: string = 'https://dev-enersound.azurewebsites.net/'; //Dev
//export const BROADCAST_SERVER_URL: string = 'http://localhost:8080/'; //Localhost
export const BROADCAST_SERVER_URL: string = 'https://enersound-broadcast.azurewebsites.net/'; //Prod
// export const BROADCAST_SERVER_URL: string = 'https://dev-enersound-broadcast.azurewebsites.net/'; //Dev

export const SESSION_URL: string = 'session';
export const SESSION_SPEECH_TOKEN_URL: string = 'session/speech-token-management';
export const SESSION_HEARTBEAT_URL: string = 'session/heartbeat';
export const USER_URL: string = 'user';
export const BILLING_URL_PATH: string = 'billing';
export const BACK_OFFICE_URL_PATH: string = 'backOffice';
export const BROADCAST_SHARECODE_URL_PATH: string = 'broadcast/sharecode';

export const DEFAULT_VOICE_INDEX = 0;

export const PACE_VALUES = [
    {
        value: 0.6,
        label: 'x0.5'
    },
    {
        value: 0.85,
        label: 'x0.75'
    },
    {
        value: 1.20,
        label: 'x1.0'
    },
    {
        value: 1.35,
        label: 'x1.25'
    },
    {
        value: 1.5,
        label: 'x1.5'
    }
    // {
    //     value: 1.75,
    //     label: 'x1.75',
    // },
    // {
    //     value: 2.0,
    //     label: 'x2.0',
    // }
];

export type Language = {
    id: string;
    name: string;
    nativeName: string | undefined;
}

export type RawSpeakRecognitionL = {
    [key: string]: string
}

export type RawText2SpeechL = {
    [key: string]: {
        name: string,
        voices: string[]
    }
}

export type RawTranslationL = {
    translation: {
        [key: string]: {
            name: string,
            nativeName: string,
            dir: string
        }
    }
}

export type RecognizableAndTranslatableLanguage = {
    // translationKey?: string, //"am"
    name: string, //Amharic
    // nativeName?: string, //አማርኛ
    recognitionKey: string //"am-ET"
}

export type TranslatableAndSpeakableLanguage = {
    speakKey: string, //"am-ET"
    name: string,
    voices: string[],
    translationKey: string, //"am"
}

export type DeviceConfig = {
    panelId: string,
    type: DeviceType,
    language?: RecognizableAndTranslatableLanguage | TranslatableAndSpeakableLanguage | null,
    gain?: number,
    pace?: number,
    device?: MediaDeviceInfo | null,
    textOnly?: boolean,
    autoDetectLang?: boolean,
    audioLevelAPIRef?: AudioLevelAPI | null,
}

export type Output = {
    id: string
    device: MediaDeviceInfo
    language: TranslatableAndSpeakableLanguage
    gain: number
    configComplete: boolean
    isExtra: boolean
    pace: number
    // getLevel(): number;
    textOnly: boolean
    voiceIndex: number
}

export type Input = {
    id: string,
    device: MediaDeviceInfo,
    language: RecognizableAndTranslatableLanguage,
    gain: number,
    configComplete: boolean,
    // getLevel(): number;
    autoDetect: boolean
}

export type TranslationResult = {
    originalText: string,
    translatedText: string,
    status: string,
    language: Language
}

export type TranslationsBody = {
    inputs: { [key: string]: string },
    outputs: { [key: string]: string }
}

export type Translation = {
    id: number,
    originalText: string,
    translatedText: string,
    name?: string,
    timestamp: number
}

export class Recognition {
    constructor(duration: number, language: Language, offset: number, text: string) {
        this.id = Math.floor(Math.random() * 100000);
        this.duration = duration;
        this.language = language;
        this.offset = offset;
        this.text = text;
        this.timestamp = Date.now();
    }

    id: number;
    duration: number;
    language: Language;
    offset: number;
    text: string;
    timestamp: number;
}

export enum SessionStates {LOADING = 'loading', ON = 'on', OFF = 'off'}


export type SessionResponse =
    | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => SessionData | PromiseLike<SessionData>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type SessionData = {
    sessionLive: boolean,
    sessionId: UUID,
    sessionSpeechToken: string,
    sessionDurationMillis: number,
    translations: Map<string, Translation[]>,
    errors: string
}

export type SpeechTokenData = {
    speechToken: string,
    expiresInSeconds?: number,
    errors: string
}

export type BadRequest = { code: 'bad_request'; message: string };

export type LoginInfo = {
    account: AccountInfo,
    token: string,
    roles: string[]
}

export type UserInfo = {
    name: string,
    email: string,
    token: string,
    accessRegistryId: string,
    userRole: string,
    userCode: string
}

// BILLING
export enum Currency {ARS = 'ARS', USD = 'USD'}

export enum PAYMENT_METHODS_OPERATIONS {
    'NONE' = 'none',
    'CREATE' = 'create',
    'UPDATE' = 'update',
}

export type PaymentMethodCreation = {
    secret: string,
    customer: string,
    stripeEnv: { name: string, publishableKey: string }
}

export type PaymentMethodGet = {
    paymentMethod: PaymentMethod,
    success: boolean
}

export type PaymentMethod = {
    paymentMethodId: string,
    stripeCustomer: string,
    brand: string,
    last4: string,
    isValid: boolean,
    expYear: string,
    expMonth: string
}

export type BroadcastSharecode = {
    userCode: string,
    sharecode: string,
    broadcastEnabled: boolean
}

export type BalanceHistory = {}

export type Balance = { //se salva diariamente? - mensualmente???
    balanceCredit: number,
    availableMinutes: number,
    ratePlanItems: RatePlanItem[],
    movements: Movement[]
    // ratePlan: RatePlan
    // id: string,
    // date: string, //?????
    // //Entradas/Salidas de dinero
    // movements: Movement[],
    // //Salidas de minutos
    // consumptions: Consumption[],
    // currentCredit: number, //?????
    // totalConsumed: number //?????
    // //con cada session cerrada se genera un DEBIT_MOV con duracion, precio unitario y costo total
}

export type RatePlan = {
    id: string,
    name: string,
    description: string,
    currency: Currency,
    items: RatePlanItem[]
}

export type RatePlanItem = {
    code: string,
    name: string,
    description: string,
    price: number
}

export type Consumption = {
    id: number,
    userId: string,
    sessionId: string,
    duration: number,
    unit_price: number, //valor del dolar en el momento de generacion de consumo
    total_cost: number,
    movId: string //?????
}

export enum MovementType {DEBIT = 'DEBIT', CREDIT = 'CREDIT', DEBIT_NOTE = 'DEBIT_NOTE', CREDIT_NOTE = 'CREDIT_NOTE', }

export enum MovementStatus {APPROVED = 'APPROVED', REJECTED = 'REJECTED'}

export type Movement = {
    id: number,
    user: string,
    timestamp: string,
    zonedTimestamp: string,
    type: MovementType,
    status: MovementStatus,
    total: number,
    currency: Currency,
    duration?: number | null,
    sessionStartTime: string | null,
    sessionEndTime: string | null,
    billedConsumptions?: BilledConsumption[],
    currentBalance: number,
    totalRatePerMin: string,
}

export type MovementDto = {
    total: number | null,
    description: string | null,
    movementType: string | null,
    customerEmail: string | null
};


//For Service GetBalance
export type BalanceSummary = {
    records: BalanceRecord[]
}
export type BalanceRecord = {
    userId: string
    date: string,
    movType: MovementType,
    duration: number,
    amount: number,
    currency: Currency,
    balance: number //in mmillis!
}

export type BilledConsumption = {
    ratePlanItemCode: string;
    ratePlanItemDesc: string;
    ratePlantItemName: string;
    lang: string;
    amount: number;
    ratePerMin: string;
    total: string;
}

export type Config = {
    inputLanguage: string | null,
    inputDevice: string | null,

    outputLanguages: { [key: string]: string },
    outputDevices: { [key: string]: string },

    sessionDuration: number
}


// DUMMIES
export const dummyEsLanguage = {
    id: 'es',
    name: 'spanish',
    nativeName: 'español'
} as Language;

export const dummyEnLanguage = {
    id: 'en',
    name: 'english',
    nativeName: 'english'
} as Language;


export type BroadcastSharecodeResponse =
    | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => BroadcastSharecode | PromiseLike<BroadcastSharecode>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type BalanceResponse =
    | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => Balance | PromiseLike<Balance>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});
export type PaymentMethodCreationResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => PaymentMethodCreation | PromiseLike<PaymentMethodCreation>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});
export type PaymentMethodGetResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => PaymentMethodGet | PromiseLike<PaymentMethodGet>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type MakePaymentResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => string | PromiseLike<string>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type RatePlanResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => RatePlan | PromiseLike<RatePlan>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});


export type Broadcast = {
    error?: string,
    translations: { [key: string]: { [key: string]: string[] } }
}

export type BroadcastResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => Broadcast | PromiseLike<Broadcast>;
}) | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
})
